export default __webpack_public_path__ + "static/GlobalImgOne-3da372cbf8f57a7a78d60a574a23acfc.webp";